import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import { useState } from "react";

import { MoveTrucksDialogProps } from "../../../interface/dialog/MoveTrucksDialogProps";
import Button from "../Button";
import FormSelectSearchField from "../form-select-search-field";
import { useDialogStyles } from "./styles";

const MoveTrucksDialog = ({
  open,
  onClose,
  transportCompanies,
  onConfirm,
  fromTransportCompanyName,
}: MoveTrucksDialogProps) => {
  const classes = useDialogStyles();
  const [selectedOption, setSelectedOption] = useState<any>(null);

  const transportCompanyOptions = transportCompanies.map((company) => ({
    label: company.name,
    value: company.id,
  }));

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => onClose(event, reason)}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle className={classes.dialogTitle}>
        {`Move "${fromTransportCompanyName}" trucks to...`}
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <FormSelectSearchField
          name="transportCompanyId"
          placeholder="Select Transport Company"
          options={transportCompanyOptions}
          value={
            transportCompanyOptions.find(
              (opt) => opt.value === selectedOption?.value
            ) || null
          }
          onChange={(option: any) => setSelectedOption(option)}
          isClearable
        />
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <div className={classes.actionButton}>
          <Button
            label="Cancel"
            type="button"
            onClick={onClose}
            color="default"
            variant="contained"
          />
        </div>
        <div className={classes.actionButton}>
          <Button
            label="Move"
            type="button"
            onClick={() => onConfirm(selectedOption.value)}
            autoFocus
            color="primary"
            variant="contained"
            disabled={!selectedOption}
          />
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default MoveTrucksDialog;
